<template>
    <div :class="['cp-mask', showModal ? 'show' : '']" v-show="showModal">
        <div class="msgbox" v-show="showModal">
            <div class="msgbox-header">
                <div class="msgbox-title">提示</div>
            </div>
            <div class="msgbox-content">
                <div class="msgbox-message">{{msg}}</div>
            </div>
            <div class="msgbox-btns">
                <button class="msgbox-btn msgbox-confirm" ref="sure" @click="close">确定</button>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    watch: {
        value(newVal) {
            this.showModal = newVal;
        }
    },
    data() {
        return {
            showModal: this.value,
            msg: ''
        };
    },
    mounted() {
      console.log(this.msg);
    },
    methods: {
      openModal(msg) {
        this.msg = msg;
        this.showModal = true;
        var promise = new Promise((resolve) => {
            this.$refs["sure"].addEventListener("click", () => {
                this.showModal = false;
                resolve("点击了确定");
            });
        });
        return promise;
      },
      close() {
        this.$emit('close');
        this.$emit("input", false);
      }
    }
  }
</script>
<style rel="stylesheet/stylus" lang="stylus" scoped>
@import '../assets/stylus/minixs/_center.styl';
    .cp-mask
        position fixed
        top 0
        left 0
        right 0
        bottom 0
        background-color rgba(0, 0, 0, .9)
        z-index 2
        visibility hidden
        opacity 0
        display flex
        justify-content center
        align-items center
        -webkit-transition-duration 400ms
        transition-duration 400ms
        &.show
            visibility visible
            opacity 1
        .msgbox {
            background-color: #fff;
            width: 6.50rem;
            border-radius: 0.03rem;
            -webkit-user-select: none;
            transition: .2s;
            text-align center

            &-header {
            padding: 0.2rem 0 0;
            color: #484848;
            font-size: 0.30rem;
            letter-spacing 0.1rem
            }

            &-content {
            padding: 0.30rem 0.20rem 0.15rem;
            border-bottom: 0.01rem solid #ddd; /*no*/
            min-height: 1.20rem;
            color: grey;
            position: relative;
            font-size: 0.20rem;
            word-wrap: break-word;
            }

            &-btns {
            height: 0.70rem;
            text-align: center;
            }

            &-confirm {
            color: rgb(38,114,255);
            width: 100%;
            }

            &-btn {
            display: block;
            background-color: #fff;
            margin: 0;
            border: 0;
            font-size: 0.28rem;
            line-height: 0.70rem;
            letter-spacing 0.1rem
            }
        }
</style>
